import React from "react";
import { Link } from "react-router-dom";

const CCardsConfigurationNavigationBar = ({ data, page }) => {
    return (
        <div className="navbar mb-4">
            <div className="d-flex nav-tabs">
                <div className={page === "categories" ? "nav-item active" : "nav-item"}>
                    <Link to="/c_card/configuration/categories" className="nav-link">
                        <span>{data.t.read("cc_categories.title")}</span>
                    </Link>
                </div>
                <div className={page === "imputations" ? "nav-item active" : "nav-item"}>
                    <Link to="/c_card/configuration/imputations" className="nav-link">
                        <span>{data.t.read("imputations")}</span>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CCardsConfigurationNavigationBar;
